import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppShellComponent } from './components/app-shell/app-shell/app-shell.component';
import { DashbaordShellComponent } from './components/dashbaord-shell/dashbaord-shell.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { IsOnBoardedGuard } from './services/isOnBoarded/is-on-boarded.guard';

const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      }
    ]
  },
  {
    path: 'profile',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuardService],
    canLoad: [AuthGuardService],
  },
  {
    path: 'profile/stores',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuardService],
    canLoad: [AuthGuardService],
  },
  {
    path: 'notifications',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'customerorder',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/customer-orders/customer-orders.module').then(m => m.CustomerOrdersModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'placeorder',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/place-order/place-order.module').then(m => m.PlaceOrderModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'payment',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'inventory',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/inventory/inventory.module').then(m => m.InventoryModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'gsn',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/gsn/gsn.module').then(m => m.GsnModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'catalogue',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/catalogue/catalogue.module').then(m => m.CatalogueModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'event-orders',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/event-orders/event-orders.module').then(m => m.EventOrdersModule)
  },
  {
    path: 'ts-orders',
    component: DashbaordShellComponent,
    loadChildren: () => import('./pages/try-at-store-orders/try-at-store-orders.module').then(m => m.TryAtStoreOrdersModule),
    canActivate: [AuthGuardService, IsOnBoardedGuard],
    canLoad: [AuthGuardService],
  },
  {
    path: 'activate-account/:token',
    component: AppShellComponent,
    loadChildren: () => import('./pages/account-activation/account-activation.module').then(m => m.AccountActivationModule)
  },
  {
    path: 'reset-password/:token',
    component: AppShellComponent,
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: '**',
    redirectTo: '/',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
